module.exports = __webpack_public_path__ + "static/img/CHIFamilyTitle.e637a5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CHIFamilyTitle.png
// module id = 657
// module chunks = 8